import React, { useState, useEffect } from "react";
import { Typography, Grid, Container, Box } from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LoaderContainer from "../../components/LoaderContainer";
import { useLocation } from "react-router-dom";
import ListGenericCard from "../../components/Custom/ListGenericCard";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../components/Custom/CustomButton";

export default function ViewMyLoan() {
  const { fpoId } = useParams();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [loanDetails, setLoanDetails] = useState([]);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [fpoDetails, setFPODetails] = useState({});
  const loanId = searchParams.get("loanId");
  const navigate = useNavigate();

  const fetchFPODetails = (fpoId) => {
    api
      .get(`/fpo/get-fpo-details?fpoId=${fpoId}`)
      .then((response) => {
        setFPODetails(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching FPO details:", error);
        setLoading(false);
      });
  };

  const fetchLenderDetails = (loanId) => {
    api
      .get(`/lending/list-loan-requests/?id=${loanId}`)
      .then((response) => {
        setLoanDetails(response.data[0]);
        console.log(loanDetails);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching lenders:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchFPODetails(fpoId);
    fetchLenderDetails(loanId);
  }, [fpoId, loanId]);

  const handleView = (documentUrl) => {
    window.open(documentUrl, "_blank"); // Open document in a new tab
  };

  const handleCardClick = (fpoId) => {
    navigate(`/lender/fpo-farmer-details/${fpoId}`);
  };

  const handleButton = () => {
    navigate("/lender/my-borrowers");
  };

  const infoItems =
    loanDetails && loanDetails.submit_user
      ? [
          { label: "Name", value: `${loanDetails.submit_user.full_name}` },
          { label: "Amount Requested", value: `${loanDetails.amount}` },
          { label: "Loan Type", value: `${loanDetails.loan_type}` },
          {
            label: "Address",
            value: "NA",
          },
          {
            label: "Operational Since",
            value: `${loanDetails.operation_since}`,
          },
          { label: "Revenue", value: `${loanDetails.revenue}` },
          {
            label: "PAN",
            value: loanDetails.submit_user.pan_number
              ? `${loanDetails.submit_user.pan_number}`
              : "Not available",
          },
          { label: "Rate of Interest", value: "NA" },
          { label: "Amount Sanctioned", value: "NA" },
          { label: "Amount Disbursed", value: "NA" },
        ]
      : [];
  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container
          maxWidth="xs"
          style={{
            height: "fit-content",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              mb: 2,
              fontSize: "30px",
              fontWeight: 700,
              marginTop: "10px",
            }}
          >
            {t("My Loan")}
          </Typography>
          <div
            style={{
              marginTop: "20px",
            }}
          >
            <Box>
              <>
                {infoItems.map((item, index) => (
                  <Grid container spacing={1} key={index}>
                    <Grid item xs={6}>
                      <Typography variant="body1" fontWeight="bold">
                        {item.label}:
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body1">{item.value}</Typography>
                    </Grid>
                  </Grid>
                ))}
              </>
            </Box>

            {fpoDetails.documents &&
              fpoDetails.documents.map((document, index) => (
                <div style={{ height: "fit-content" }} key={index}>
                  <ListGenericCard
                    title={`${document.name}`}
                    onClick={() => handleView(document.document)}
                  />
                </div>
              ))}

            {fpoDetails.farmers?.length > 0 && (
              <div style={{ height: "fit-content" }}>
                <ListGenericCard
                  title={"Farmer List"}
                  onClick={() => handleCardClick(fpoId)}
                />
              </div>
            )}
          </div>

          <CustomButton onClick={handleButton} hideIcon>
            {t("Back")}
          </CustomButton>
        </Container>
      </LoaderContainer>
    </>
  );
}
